import { AppSettings } from '@app/base';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useField } from 'formik';

export interface FormHCaptchaProps {
  name: string;
}

export function FormHCaptcha(props: FormHCaptchaProps) {
  const { name } = props;
  const [, , { setValue, setTouched }] = useField<string | null>(name);

  const onVerify = (token: string) => {
    setTouched(true);
    setValue(token ?? null, true);
  };

  const onExpire = () => {
    setValue(null, true);
  };

  return (
    <HCaptcha
      languageOverride="en"
      sitekey={AppSettings.hCaptcha.siteKey}
      onVerify={onVerify}
      onExpire={onExpire}
    />
  );
}
